<template>
  <div class="textblock">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">{{ headline }}</h1>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-size-6 is-size-7-mobile">
            {{ column1 }}
            <br />
            <br />
            {{ column2 }}
          </div>
          <div class="column is-size-6 is-size-7-mobile">
            <figure class="image">
              <img
                sizes="(max-width: 7500px) 40vw, 3000px"
                srcset="../assets/images/Honig-aus-2021-380.jpg  380w, ../assets/images/Honig-aus-2021-440.jpg  440w, ../assets/images/Honig-aus-2021-500.jpg  500w, ../assets/images/Honig-aus-2021-560.jpg  560w, ../assets/images/Honig-aus-2021-620.jpg  620w, ../assets/images/Honig-aus-2021-680.jpg  680w, ../assets/images/Honig-aus-2021-740.jpg  740w, ../assets/images/Honig-aus-2021-800.jpg  800w, ../assets/images/Honig-aus-2021-860.jpg  860w, ../assets/images/Honig-aus-2021-920.jpg  920w, ../assets/images/Honig-aus-2021-980.jpg  980w, ../assets/images/Honig-aus-2021-1040.jpg 1040w, ../assets/images/Honig-aus-2021-1100.jpg 1100w, ../assets/images/Honig-aus-2021-1160.jpg 1160w, ../assets/images/Honig-aus-2021-1220.jpg 1220w"
                src="../assets/images/Honig-aus-2021-1220.jpg"
                alt="Aufnahme von einem Glas Honig in einer Hand vor einer Blühwiese."
              />
            </figure>
            <p class="smallspacetop">
              <b>Von der Wiese ins Glas:</b>
              <br />Echter deutscher Imkerhonig aus der Blühsaison 2021.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextblockHoney",
  props: {
    headline: String,
    column1: String,
    column2: String
  }
};
</script>

<style lang="scss"></style>
